import { render } from "./ShowLotSearchResult.vue?vue&type=template&id=35e4daac"
import script from "./ShowLotSearchResult.vue?vue&type=script&lang=js"
export * from "./ShowLotSearchResult.vue?vue&type=script&lang=js"
script.render = render

export default script